<h5 mat-dialog-title mat-dialog-draggable-title>
  <div class="d-flex justify-content-between">
    <div>{{'title.add_customer' | translate}}</div>
    <div>
      <button (click)="openPopupRecognitionAI()" mat-raised-button type="button" color="primary">
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clip-path="url(#clip0_6923_50396)">
          <path d="M9.99998 12.6667C11.4727 12.6667 12.6666 11.4728 12.6666 10C12.6666 8.52725 11.4727 7.33334 9.99998 7.33334C8.52722 7.33334 7.33331 8.52725 7.33331 10C7.33331 11.4728 8.52722 12.6667 9.99998 12.6667Z" fill="white"/>
          <path d="M7.50002 1.66666L5.97502 3.33332H3.33335C2.41669 3.33332 1.66669 4.08332 1.66669 4.99999V15C1.66669 15.9167 2.41669 16.6667 3.33335 16.6667H16.6667C17.5834 16.6667 18.3334 15.9167 18.3334 15V4.99999C18.3334 4.08332 17.5834 3.33332 16.6667 3.33332H14.025L12.5 1.66666H7.50002ZM10 14.1667C7.70002 14.1667 5.83335 12.3 5.83335 9.99999C5.83335 7.69999 7.70002 5.83332 10 5.83332C12.3 5.83332 14.1667 7.69999 14.1667 9.99999C14.1667 12.3 12.3 14.1667 10 14.1667Z" fill="white"/>
          </g>
          <defs>
          <clipPath id="clip0_6923_50396">
          <rect width="20" height="20" fill="white"/>
          </clipPath>
          </defs>
          </svg>
        {{ 'button.AI_recognition' | translate }}
      </button>
      <button type="button" class="close ml-3" aria-label="Close" (click)="onClickBtnCancel()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
  </div>
</h5>

<form #f="ngForm" [appCheckInputNumber]="['','','accountNumber', 'certificateNo', 'representativeCertificateNo']"
  [appCheckPhone]="['phone', 'fax']" appFocusFirstElement>
  <mat-dialog-content style="padding: 8px 24px;">
    <mat-tab-group #myTabGroup (selectedIndexChange)="isInforTab = $event"
      *ngIf="userType == 1 || (userType == 2 && permissions.includes(4))">
      <mat-tab [label]="'title.customer_detail_upper' | translate">
      </mat-tab>
      <mat-tab [label]="'title.config_group_customer' | translate">
        <app-customer-configuration (onChangeGroupCustomerIds)="onChangeGroupCustomerIds($event)">
        </app-customer-configuration>
      </mat-tab>
    </mat-tab-group>
    <mat-card-content [ngClass]="isInforTab === 0 ? '' : 'd-none'">
      <mat-accordion #accordion="matAccordion" [multi]="true">
        <!-- Thông tin khách hàng -->
        <mat-expansion-panel expanded="true">
          <mat-expansion-panel-header>
            <mat-panel-title class="mat-panel-title">
              {{'title.customer_info' | translate}}
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="row">
            <!--loại khách hàng-->
            <div class="col-md-8">
              <mat-form-field class="w-100">
                <mat-label>{{'form.customer_type' | translate}}</mat-label>
                <mat-select (focusout)="(checkFocus = true)"
                  (focus)="commonService.openComboBox(checkFocus, focusSelect)" id="customerType" cdkFocusInitial
                  (selectionChange)="checkFocus = false; changeRepresentativeCertificateType(); onChangeType()"
                  #focusSelect name="customerType" [(ngModel)]="customer.customerType" #customerType="ngModel"
                  [ngClass]="{ 'is-invalid': f.submitted && customerType.invalid }" required>
                  <mat-option>
                    <ngx-mat-select-search [noEntriesFoundLabel]="'autocomplete.suggestion' | translate"
                      [placeholderLabel]="'search_form.search' | translate" [formControl]="enterpriseTypeFilterCtrl">
                    </ngx-mat-select-search>
                  </mat-option>
                  <mat-option [value]="null"> {{'form.select_address' | translate}} </mat-option>
                  <mat-option *ngFor="let enterpirse of filteredEnterpriseType | async" [value]="enterpirse.id"
                    (click)="this.commonService.closeDropdownList(this.focusSelect)" title="{{enterpirse.name}}">
                    {{enterpirse.name}}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="f.submitted || customerType.invalid">
                  <span class="text-error" *ngIf="customerType?.errors?.required">
                    {{'validation.customer_type' | translate}}
                  </span>
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col-md-4">
              <mat-form-field class="w-100">
                <mat-label>{{'headertable.customer_code' | translate}}</mat-label>
                <input matInput (focusout)="customer.customerCode = customer.customerCode.trim()"
                       autocomplete="off" type="text" name="customerCode" pattern="^\S+$"
                       [(ngModel)]="customer.customerCode" id="customerCode" #customerCode="ngModel" maxlength="50"/>
                <button mat-button *ngIf="customer.customerCode" type="button" matSuffix mat-icon-button aria-label="Clear"
                        (click)="customer.customerCode=''">
                  <mat-icon>close</mat-icon>
                </button>
                <mat-error *ngIf="customerCode?.errors?.pattern">
                  {{'headertable.error_customerCode' | translate}}
                </mat-error>
                <mat-error *ngIf="customerCode?.errors?.duplicate">
                  {{'headertable.error_customerCodeExist'|translate}}
                </mat-error>
              </mat-form-field>
            </div>

            <!--khách hàng-->
            <div class="{{customer.customerType == personalId ? 'col-md-4' : 'col-md-8'}}">
              <mat-form-field class="w-100">
                <input (focusout)="customer.name=customer.name.trim()" matInput
                  [placeholder]="'headertable.customer_name' | translate" autocomplete="off" type="text" name="name"
                  [(ngModel)]="customer.name" #name="ngModel" [ngClass]="{ 'is-invalid': f.submitted && name.invalid }"
                  required maxlength="200" />
                <button mat-button *ngIf="customer.name" type="button" matSuffix mat-icon-button aria-label="Clear"
                  (click)="customer.name=''">
                  <mat-icon>close</mat-icon>
                </button>
                <mat-error *ngIf="f.submitted || name.invalid || name?.errors?.required">
                  {{'validation.customer_name' | translate}}
                </mat-error>
              </mat-form-field>
            </div>

            <!--ngày sinh-->
            <div class="col-md-4" *ngIf="customer.customerType == personalId">
              <mat-form-field class="w-100">
                <input matInput [placeholder]="'form.birthday' | translate" autocomplete="off" [max]="maxDate"
                  (dateInput)="addEvent($event)"
                  (change)="this.commonService.resetDatePicker(pickerInput2.value, this.ngForm.controls['birthday'])"
                  (dateChange)="addEvent($event)" [matDatepicker]="birthday1" name="birthday"
                  [(ngModel)]="customer.birthday" maxlength="10" #birthday2="ngModel" #pickerInput2 />
                <mat-datepicker-toggle matSuffix [for]="birthday1"></mat-datepicker-toggle>
                <mat-datepicker #birthday1></mat-datepicker>
                <mat-error *ngIf="f.submitted || birthday2.invalid">
                  {{getErrorDateMessage(pickerInput2.value)}}
                </mat-error>
              </mat-form-field>
            </div>

            <!--giới tính-->
            <!-- <div class="col-md-4" *ngIf="customer.customerType == personalId">
                <mat-form-field class="w-100">
                  <mat-label>{{'form.sex' | translate}}</mat-label>
                  <mat-select #sexSelect1 (focusout)="(checkFocus = true)" (selectionChange)="checkFocus = false"
                    (focus)="commonService.openComboBox(checkFocus, sexSelect1)" id="sex" name="sex"
                    [(ngModel)]="customer.sex">
                    <mat-option [value]="true" (click)="this.commonService.closeDropdownList(this.sexSelect1)">
                      {{'form.male' | translate}}</mat-option>
                    <mat-option [value]="false" (click)="this.commonService.closeDropdownList(this.sexSelect1)">
                      {{'form.female' | translate}}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div> -->
            <div class="col-md-4" *ngIf="customer.customerType == personalId">
              <mat-label style="color: #858796">{{'form.sex' | translate}}</mat-label><br>
              <mat-radio-group #sexSelect1 id="sex" name="sex" [(ngModel)]="customer.sex">
                <mat-radio-button [value]="true" class="pt-2 mr-3">{{'form.male' | translate}}</mat-radio-button>
                <mat-radio-button [value]="false">{{'form.female' | translate}}</mat-radio-button>
              </mat-radio-group>
            </div>

            <!--mã số thuế-->
            <div class="col-md-4" *ngIf="customer.customerType != personalId && customer.customerType != null">
              <mat-form-field class="w-100">
                <input (focusout)="customer.taxCode=customer.taxCode.trim()" matInput type="text"
                  [placeholder]="'form.tax_code' | translate" name="taxCode" [(ngModel)]="customer.taxCode"
                  #taxCode="ngModel" [ngClass]="{ 'is-invalid': f.submitted || taxCode.invalid }"
                  [maxlength]="taxCodeMaxlength" id="taxCode" [matAutocomplete]="auto"
                  (input)="changeCertificate($event,'taxCode')" required maxlength="20" />

                <mat-autocomplete #auto="matAutocomplete"
                  (optionSelected)="onSelectionChangeCertificate($event,'taxCode')">
                  <mat-option *ngFor="let state of filteredStatesTaxCode" [value]="state.taxCode">
                    <span>{{ state.name }}</span> |
                    <small>Email: {{state.email}}</small>
                  </mat-option>
                </mat-autocomplete>
                <mat-spinner *ngIf="isLoadingTaxCode" class="spinner" diameter="20" matSuffix></mat-spinner>
                <button mat-button *ngIf="customer.taxCode && !isLoadingTaxCode" type="button" matSuffix mat-icon-button
                  aria-label="Clear" (click)="clearTaxCode()">
                  <mat-icon>close</mat-icon>
                </button>
                <!-- <mat-error *ngIf="(f.submitted || taxCode.invalid) && taxCode?.errors?.validIp">
                  {{'validation.tax_code_number' | translate}}
                </mat-error> -->
                <mat-error *ngIf="taxCode?.errors?.duplicate">
                  {{ 'validation.err_cust_tax_code_duplicate' | translate }}
                </mat-error>
                <mat-error *ngIf="f.submitted || taxCode?.errors?.required">
                  {{'validation.code_tax_request' | translate}}
                </mat-error>
              </mat-form-field>
            </div>

            <!--loại giấy tờ-->
            <div class="col-md-4">
              <mat-form-field class="w-100">
                <mat-label>{{'form.type_certification' | translate}}</mat-label>
                <mat-select #certificationTypeSelect (focusout)="(checkFocus = true)"
                  (selectionChange)="checkFocus = false; "
                  (focus)="commonService.openComboBox(checkFocus, certificationTypeSelect)" id="certificateId"
                  name="certificateId" [(ngModel)]="customer.certificateId" #certificateId="ngModel"
                  [ngClass]="{ 'is-invalid': f.submitted && certificateId.invalid }" required>
                  <mat-option>
                    <ngx-mat-select-search [noEntriesFoundLabel]="'autocomplete.suggestion' | translate"
                      [placeholderLabel]="'search_form.search' | translate" [formControl]="customer.customerType == personalId
                        ? representativeCertificateTypeFilterCtrl : certificationTypeFilterCtrl">
                    </ngx-mat-select-search>
                  </mat-option>
                  <mat-option *ngFor="let certificate of (customer.customerType == personalId
                      ? filteredRepresentativeCertificateType : filteredCertificationType) | async"
                    [value]="certificate.id"
                    (click)="this.commonService.closeDropdownList(this.certificationTypeSelect)">
                    {{certificate.name}}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="f.submitted || certificateId.invalid">
                  <span class="text-error" *ngIf="certificateId?.errors?.required">
                    {{'validation.type_of_doc' | translate}}
                  </span>
                </mat-error>
              </mat-form-field>
            </div>

            <!--số giấy tờ của loại KH là Cá nhân-->
            <div class="col-md-4" *ngIf="customer.customerType == personalId">
              <mat-form-field class="w-100">
                <input (focusout)="customer.certificateNo=customer.certificateNo.trim()" matInput autocomplete="off"
                  [placeholder]="'form.certification_no' | translate" type="text" name="certificateNo1"
                  [(ngModel)]="customer.certificateNo" #certificateNo1="ngModel"
                  [ngClass]="{ 'is-invalid': f.submitted && certificateNo1.invalid }" required maxlength="20"
                  [pattern]="certificateNoPattern" id="certificateNo1" [matAutocomplete]="auto"
                  (input)="changeCertificate($event, 'cerNo')" />

                <mat-autocomplete #auto="matAutocomplete"
                  (optionSelected)="onSelectionChangeCertificate($event,'cerNo')">
                  <mat-option *ngFor="let state of filteredStates" [value]="state.certificateNo">
                    <span>{{ state.name }}</span> |
                    <small>Email: {{state.email}}</small>
                  </mat-option>
                </mat-autocomplete>
                <mat-spinner *ngIf="isLoadingCerNo" class="spinner" diameter="20" matSuffix></mat-spinner>

                <button mat-button *ngIf="customer.certificateNo && !isLoadingCerNo" type="button" matSuffix
                  mat-icon-button aria-label="Clear" (click)="clearCerNo()">
                  <mat-icon>close</mat-icon>
                </button>
                <mat-error *ngIf="(f.submitted || certificateNo1.invalid) && certificateNo1?.errors?.required">
                  {{'validation.number_of_doc' | translate}}
                </mat-error>
                <mat-error *ngIf="certificateNo1?.errors?.pattern">
                  {{'validation.gpkd_format' | translate}}
                </mat-error>
                <mat-error *ngIf="certificateNo1?.errors?.duplicate">
                  {{ 'validation.err_cust_certificate_no_duplicate' | translate }}
                </mat-error>
              </mat-form-field>
            </div>

            <!--số giấy tờ của loại KH là Công ty, Cơ quan-->
            <div class="col-md-4" *ngIf="customer.customerType != personalId">
              <mat-form-field class="w-100">
                <input (focusout)="customer.certificateNo=customer.certificateNo.trim()" matInput autocomplete="off"
                  [placeholder]="'form.certification_no' | translate" type="text" name="certificateNo"
                  [(ngModel)]="customer.certificateNo" #certificateNo="ngModel"
                  [ngClass]="{ 'is-invalid': f.submitted && certificateNo.invalid }" required maxlength="20"
                  id="certificateNo" [matAutocomplete]="auto" (input)="changeCertificate($event, 'cerNo')" />

                <mat-autocomplete #auto="matAutocomplete"
                  (optionSelected)="onSelectionChangeCertificate($event,'cerNo')">
                  <mat-option *ngFor="let state of filteredStates" [value]="state.certificateNo">
                    <span>{{ state.name }}</span> |
                    <small>Email: {{state.email}}</small>
                  </mat-option>
                </mat-autocomplete>
                <mat-spinner *ngIf="isLoadingCerNo" class="spinner" diameter="20" matSuffix></mat-spinner>

                <button mat-button *ngIf="customer.certificateNo && !isLoadingCerNo" type="button" matSuffix
                  mat-icon-button aria-label="Clear" (click)="clearCerNo()">
                  <mat-icon>close</mat-icon>
                </button>
                <mat-error *ngIf="(f.submitted || certificateNo.invalid) && certificateNo?.errors?.required">
                  <span *ngIf="certificateNo?.errors?.required" class="text-error">{{'validation.number_of_doc' |
                    translate}}
                  </span>
                </mat-error>
                <mat-error *ngIf="(f.submitted || certificateNo.invalid) && certificateNo?.errors?.validInput">
                  {{'validation.gpkd_format' | translate}}
                </mat-error>
                <mat-error *ngIf="certificateNo?.errors?.duplicate">
                  {{ 'validation.err_cust_certificate_no_duplicate' | translate }}
                </mat-error>
              </mat-form-field>
            </div>

            <!--ngày cấp-->
            <div class="col-md-4">
              <mat-form-field class="w-100">
                <input autocomplete="off" [placeholder]="'form.issued_date' | translate" matInput
                  [matDatepicker]="issuedDate1" [max]="maxDate" name="issuedDate" [(ngModel)]="customer.issuedDate"
                  #issuedDate="ngModel" (dateInput)="addEvent($event)" (dateChange)="addEvent($event)"
                  [ngClass]="{ 'is-invalid': f.submitted && issuedDate.invalid }" required maxlength="10"
                  #birthday3="ngModel" #pickerInput3 (keyup)="checkIssuedDateChange(pickerInput3.value)" />
                <mat-datepicker-toggle matSuffix [for]="issuedDate1"></mat-datepicker-toggle>
                <mat-datepicker #issuedDate1></mat-datepicker>
                <mat-error *ngIf="f.submitted || birthday3.invalid">
                  {{getErrorDateMessage(pickerInput3.value)}}
                </mat-error>
                <mat-error *ngIf="checkIssuedDate">
                  {{'validation.issued_date' | translate}}
                </mat-error>
              </mat-form-field>
            </div>

            <!--nơi cấp-->
            <div class="col-md-8">
              <mat-form-field class="w-100">
                <input (focusout)="customer.issuedAt=customer.issuedAt.trim()" matInput autocomplete="off"
                  [placeholder]="'form.issued_by' | translate" type="text" name="issuedAt"
                  [(ngModel)]="customer.issuedAt" #issuedAt="ngModel"
                  [ngClass]="{ 'is-invalid': f.submitted && issuedAt.invalid }" required maxlength="50" />
                <button mat-button *ngIf="customer.issuedAt" type="button" matSuffix mat-icon-button aria-label="Clear"
                  (click)="customer.issuedAt=''">
                  <mat-icon>close</mat-icon>
                </button>
                <mat-error *ngIf="(f.submitted || issuedAt.invalid) && issuedAt?.errors?.required">
                  {{'validation.issued_by' | translate}}
                </mat-error>
              </mat-form-field>
            </div>
          </div>
        </mat-expansion-panel>

        <!-- Phần chưa cập nhật => Thông tin người đại diện -->
        <mat-expansion-panel *ngIf="customer.customerType != personalId && customer.customerType != null">
          <mat-expansion-panel-header>
            <mat-panel-title class="mat-panel-title">
              {{'title.representative_info' | translate}}
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="row">
            <div class="col-sm-4">
              <mat-form-field class="w-100">
                <input (focusout)="customer.representative=customer.representative.trim()" matInput autocomplete="off"
                  [placeholder]="'form.full_name' | translate" type="text" name="representative"
                  [(ngModel)]="customer.representative" #representative="ngModel"
                  [ngClass]="{ 'is-invalid': f.submitted && representative.invalid }" required maxlength="200" />
                <button mat-button *ngIf="customer.representative" type="button" matSuffix mat-icon-button
                  aria-label="Clear" (click)="customer.representative=''">
                  <mat-icon>close</mat-icon>
                </button>
                <mat-error *ngIf="f.submitted && representative.invalid && representative?.errors?.required">
                  {{'validation.representative' | translate}}
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col-sm-4">
              <mat-form-field class="w-100">
                <input (focusout)="customer.position=customer.position.trim()" matInput autocomplete="off" type="text"
                  [placeholder]="'form.position' | translate" name="position" [(ngModel)]="customer.position"
                  #position="ngModel" [ngClass]="{ 'is-invalid': f.submitted && position.invalid }" required
                  maxlength="200" />
                <button mat-button *ngIf="customer.position" type="button" matSuffix mat-icon-button aria-label="Clear"
                  (click)="customer.position=''">
                  <mat-icon>close</mat-icon>
                </button>
                <mat-error *ngIf="f.submitted && position.invalid && position?.errors?.required">
                  {{'validation.position' | translate}}
                </mat-error>
              </mat-form-field>
            </div>

            <div class="col-md-4">
              <mat-label style="color: #858796">{{'form.sex' | translate}}</mat-label><br>
              <mat-radio-group #sexSelect2 id="sex" name="sex" [(ngModel)]="customer.sex">
                <mat-radio-button [value]="true" class="pt-2 mr-3">{{'form.male' | translate}}</mat-radio-button>
                <mat-radio-button [value]="false">{{'form.female' | translate}}</mat-radio-button>
              </mat-radio-group>
            </div>

            <div class="col-md-4">
              <mat-form-field class="w-100">
                <input autocomplete="off" matInput [placeholder]="'form.birthday' | translate"
                  (change)="this.commonService.resetDatePicker(pickerInput4.value, this.ngForm.controls['birthday'])"
                  [matDatepicker]="birthday1" [max]="maxDate" name="birthday" [(ngModel)]="customer.birthday"
                  maxlength="10" #birthday4="ngModel" #pickerInput4 (dateInput)="addEvent($event)"
                  (dateChange)="addEvent($event)" />
                <mat-datepicker-toggle matSuffix [for]="birthday1"></mat-datepicker-toggle>
                <mat-datepicker #birthday1></mat-datepicker>
                <mat-error *ngIf="f.submitted || birthday4.invalid">
                  {{getErrorDateMessage(pickerInput4.value)}}
                </mat-error>
              </mat-form-field>
            </div>

            <!-- <div class="col-md-4">
              <mat-form-field class="w-100">
                <mat-label>{{'form.sex' | translate}}</mat-label>
                <mat-select #sexSelect2 (focusout)="(checkFocus = true)" (selectionChange)="checkFocus = false"
                  (focus)="commonService.openComboBox(checkFocus, sexSelect2)" id="sex" name="sex"
                  [(ngModel)]="customer.sex">
                  <mat-option value="true" (click)="this.commonService.closeDropdownList(this.sexSelect2)">
                    {{'form.male' | translate}}</mat-option>
                  <mat-option value="false" (click)="this.commonService.closeDropdownList(this.sexSelect2)">
                    {{'form.female' | translate}}</mat-option>
                </mat-select>
              </mat-form-field>
            </div> -->

            <div class="col-md-4">
              <mat-form-field class="w-100">
                <mat-label>{{'form.type_certification' | translate}}</mat-label>
                <mat-select #representativeCertificateTypeSelect (focusout)="(checkFocus = true)"
                  (selectionChange)="checkFocus = false"
                  (focus)="commonService.openComboBox(checkFocus, representativeCertificateTypeSelect)"
                  id="representativeCertificateId" name="representativeCertificateId"
                  [(ngModel)]="customer.representativeCertificateId">
                  <mat-option>
                    <ngx-mat-select-search [noEntriesFoundLabel]="'autocomplete.suggestion' | translate"
                      [placeholderLabel]="'search_form.search' | translate"
                      [formControl]="representativeCertificateTypeFilterCtrl">
                    </ngx-mat-select-search>
                  </mat-option>
                  <mat-option
                    *ngFor="let representativeCertificateType of filteredRepresentativeCertificateType | async"
                    [value]="representativeCertificateType.id"
                    (click)="this.commonService.closeDropdownList(this.representativeCertificateTypeSelect)">
                    {{representativeCertificateType.name}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <div class="col-md-4">
              <mat-form-field class="w-100">
                <input (focusout)="customer.representativeCertificateNo=customer.representativeCertificateNo.trim()"
                  matInput autocomplete="off" [placeholder]="'form.certification_no' | translate" type="text"
                  name="representativeCertificateNo" #representativeCertificateNo="ngModel"
                  [(ngModel)]="customer.representativeCertificateNo" maxlength="20" />
                <button mat-button *ngIf="customer.representativeCertificateNo" matSuffix mat-icon-button
                  aria-label="Clear" (click)="customer.representativeCertificateNo=''">
                  <mat-icon>close</mat-icon>
                </button>
                <mat-error
                  *ngIf="f.submitted && representativeCertificateNo.invalid && representativeCertificateNo?.errors?.validInput">
                  {{'validation.gpkd_format' | translate}}
                </mat-error>
              </mat-form-field>
            </div>

            <div class="col-md-4">
              <mat-form-field class="w-100">
                <input autocomplete="off" [placeholder]="'form.issued_date' | translate" matInput
                  (change)="this.commonService.resetDatePicker(pickerInput5.value, this.ngForm.controls['representativeIssuedDate'])"
                  [matDatepicker]="representativeIssuedDate1" [max]="maxDate" name="representativeIssuedDate"
                  [(ngModel)]="customer.representativeIssuedDate" maxlength="10" #birthday5="ngModel" #pickerInput5
                  (dateInput)="addEvent($event)" (dateChange)="addEvent($event)" />
                <mat-datepicker-toggle matSuffix [for]="representativeIssuedDate1"></mat-datepicker-toggle>
                <mat-datepicker #representativeIssuedDate1></mat-datepicker>
                <mat-error *ngIf="f.submitted || birthday5.invalid">
                  {{getErrorDateMessage(pickerInput5.value)}}
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col-md-4">
              <mat-form-field class="w-100">
                <input (focusout)="customer.representativeIssuedAt=customer.representativeIssuedAt.trim()" matInput
                  [placeholder]="'form.issued_by' | translate" autocomplete="off" type="text"
                  name="representativeIssuedOn" [(ngModel)]="customer.representativeIssuedAt" maxlength="200" />
                <button mat-button *ngIf="customer.representativeIssuedAt" type="button" matSuffix mat-icon-button
                  aria-label="Clear" (click)="customer.representativeIssuedAt=''">
                  <mat-icon>close</mat-icon>
                </button>
              </mat-form-field>
            </div>
          </div>
        </mat-expansion-panel>

        <!-- Thông tin liên hệ -->
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title class="mat-panel-title justify-content-between">
              <span>{{'title.contact_info' | translate}}</span>
              <small class="form-text text-gray">(<span style="color: red;">*</span>) {{'form.info' |
                translate}}</small>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="row font-weight-bold">
            <div class="col-12">
              <div class="d-flex align-items-center">
                <div style="font-size: 15px; color:#000000DE" class="">{{'form.use_new_area' | translate}}</div>
                <div class="d-flex pl-2">
                  <div (click)="changeAddress(true)"
                    [ngClass]="customer.isNewAddress ? 'status-document' : 'text-off-document'"
                    style="cursor: pointer; border-right: none; font-weight: 600; border: 1px solid #D9D9D9; padding: 2px 10px; border-bottom-left-radius: 3px; border-top-left-radius: 3px;">
                    {{'user_group.on_document' | translate}}</div>
                  <div (click)="changeAddress(false)"
                    [ngClass]="!customer.isNewAddress ? 'status-document' : 'text-off-document'"
                    style="cursor: pointer; border-left: none; font-weight: 600; border: 1px solid #D9D9D9; padding: 2px 10px; border-bottom-right-radius: 3px; border-top-right-radius: 3px;">
                    {{'user_group.off_document' | translate}}</div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <!-- tỉnh/Thành phố -->
            <div class="col-sm-4">
              <mat-form-field class="w-100">
                <mat-label>{{'form.city' | translate}}</mat-label>
                <mat-select #citySelect (focusout)="(checkFocus = true)"
                  (focus)="commonService.openComboBox(checkFocus, citySelect)" id="cityId" name="cityId"
                  (selectionChange)="checkFocus = false; onChange($event.value, customer.isNewAddress ? 2: 1);" [(ngModel)]="customer.cityId"
                  #cityId="ngModel" [ngClass]="{ 'is-invalid': f.submitted && cityId.invalid }" required
                  maxlength="100">
                  <mat-option>
                    <ngx-mat-select-search [noEntriesFoundLabel]="'autocomplete.suggestion' | translate"
                      [placeholderLabel]="'search_form.search' | translate" [formControl]="cityFilterCtrl">
                    </ngx-mat-select-search>
                  </mat-option>
                  <mat-option [value]="null" selected>{{'form.select_address' | translate}}</mat-option>
                  <mat-option *ngFor="let city of filteredCity | async" [value]="city.id"
                    (click)="this.commonService.closeDropdownList(this.citySelect)">
                    {{ city.name }}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="(f.submitted || cityId.invalid) && cityId?.errors?.required">
                  {{'validation.city' | translate}}
                </mat-error>
              </mat-form-field>
            </div>

            <!-- quận/Huyện -->
            <div class="col-sm-4" *ngIf="!customer.isNewAddress">
              <mat-form-field class="w-100">
                <mat-label>{{'form.district' | translate}}</mat-label>
                <mat-select #districtSelect (focusout)="(checkFocus = true)"
                  (focus)="commonService.openComboBox(checkFocus, districtSelect)" id="districtId" name="districtId"
                  (selectionChange)="checkFocus = false; onChange($event.value, 2);" [(ngModel)]="customer.districtId"
                  #districtId="ngModel"
                  maxlength="100">
                  <mat-option>
                    <ngx-mat-select-search [noEntriesFoundLabel]="'autocomplete.suggestion' | translate"
                      [placeholderLabel]="'search_form.search' | translate" [formControl]="districtsFilterCtrl">
                    </ngx-mat-select-search>
                  </mat-option>
                  <mat-option [value]="null" selected>{{'form.select_address' | translate}}</mat-option>
                  <mat-option *ngFor="let district of filteredDistricts | async" [value]="district.id"
                    (click)="this.commonService.closeDropdownList(this.districtSelect)">
                    {{ district.name }}
                  </mat-option>
                </mat-select>
<!--                <mat-error *ngIf="f.submitted || districtId.invalid || districtId?.errors?.required">-->
<!--                  {{'validation.district' | translate}}-->
<!--                </mat-error>-->
              </mat-form-field>
            </div>

            <!-- phường/Xã -->
            <div class="col-sm-4">
              <ng-container *ngIf="notHasWard; else hasWard">
                <mat-form-field class="w-100">
                  <mat-label>{{'form.ward' | translate}}</mat-label>
                  <mat-select (focusout)="(checkFocus = true)" (selectionChange)="checkFocus = false"
                    (focus)="commonService.openComboBox(checkFocus, wardSelect1)" id="wardId" name="wardId" #wardSelect1
                    [(ngModel)]="customer.wardId" #wardId="ngModel" maxlength="100">
                    <mat-option>
                      <ngx-mat-select-search [noEntriesFoundLabel]="'autocomplete.suggestion' | translate"
                        [placeholderLabel]="'search_form.search' | translate" [formControl]="wardFilterCtrl">
                      </ngx-mat-select-search>
                    </mat-option>
                    <mat-option [value]="null" selected>{{'form.select_address' | translate}}</mat-option>
                    <mat-option *ngFor="let ward of filteredWard | async" [value]="ward.id">
                      {{ ward.name }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </ng-container>
              <ng-template #hasWard>
                <mat-form-field class="w-100">
                  <mat-label>{{'form.ward' | translate}}</mat-label>
                  <mat-select #wardSelect (focusout)="(checkFocus = true)" (selectionChange)="checkFocus = false"
                    (focus)="commonService.openComboBox(checkFocus, wardSelect)" id="wardId" name="wardId"
                    [(ngModel)]="customer.wardId" #wardId="ngModel"
                     maxlength="100">
                    <mat-option>
                      <ngx-mat-select-search [noEntriesFoundLabel]="'autocomplete.suggestion' | translate"
                        [placeholderLabel]="'search_form.search' | translate" [formControl]="wardFilterCtrl">
                      </ngx-mat-select-search>
                    </mat-option>
                    <mat-option [value]="null" selected>{{'form.select_address' | translate}}</mat-option>
                    <mat-option *ngFor="let ward of filteredWard | async" [value]="ward.id"
                      (click)="this.commonService.closeDropdownList(this.wardSelect)">
                      {{ ward.name }}
                    </mat-option>
                  </mat-select>

                </mat-form-field>
              </ng-template>
            </div>

            <!-- địa chỉ -->
            <div class="col-md-4">
              <mat-form-field class="w-100">
                <input (focusout)="customer.address=customer.address.trim()" matInput autocomplete="off"
                  [placeholder]="'headertable.address' | translate" type="text" name="address"
                  [(ngModel)]="customer.address" #address="ngModel"
                  [ngClass]="{ 'is-invalid': f.submitted && address.invalid }" required maxlength="200" />
                <button mat-button *ngIf="customer.address" type="button" matSuffix mat-icon-button aria-label="Clear"
                  (click)="customer.address=''">
                  <mat-icon>close</mat-icon>
                </button>
                <mat-error *ngIf="(f.submitted || address.invalid) && address?.errors?.required">
                  {{'validation.address' | translate}}
                </mat-error>
              </mat-form-field>
            </div>

            <!-- email -->
            <div class="col-md-4">
              <mat-form-field class="w-100">
                <mat-label>{{'form.email' | translate}}</mat-label>
                <input (focusout)="customer.email=customer.email.trim()" matInput autocomplete="off" type="text"
                  [placeholder]="'placeholder.email' | translate" name="email" [(ngModel)]="customer.email"
                  #email="ngModel" [required]="scopeType == 1" [maxlength]="emailMaxlength" [pattern]="emailPattern" />
                <button mat-button *ngIf="customer.email" type="button" matSuffix mat-icon-button aria-label="Clear"
                  (click)="customer.email=''">
                  <mat-icon>close</mat-icon>
                </button>
                <mat-error *ngIf="f.submitted || email.invalid">
                  <span class="text-error" *ngIf="email?.errors?.required && scopeType == 1">
                    {{'validation.email' | translate}}
                  </span>
                  <span class="text-error" *ngIf="email?.errors?.pattern">
                    {{'validation.email_format' | translate}}
                  </span>
                </mat-error>
              </mat-form-field>
            </div>

            <!-- fax -->
            <div class="col-md-4">
              <mat-form-field class="w-100">
                <input (focusout)="customer.fax=customer.fax.trim()" matInput autocomplete="off"
                  [placeholder]="'form.fax' | translate" type="text" name="fax" [(ngModel)]="customer.fax"
                  #fax="ngModel" maxlength="20" />
                <button mat-button *ngIf="customer.fax" type="button" matSuffix mat-icon-button aria-label="Clear"
                  (click)="customer.fax=''">
                  <mat-icon>close</mat-icon>
                </button>
                <mat-error *ngIf="f.submitted || fax.invalid && fax?.errors?.validInput">
                  {{'validation.fax_format' | translate}}
                </mat-error>
              </mat-form-field>
            </div>

            <!-- điện thoại -->
            <div class="col-md-4">
              <mat-form-field class="w-100">
                <input (focusout)="customer.phone=customer.phone.trim()" matInput autocomplete="off" type="text"
                  [placeholder]="'search_form.phone' | translate" name="phoneNumber" [(ngModel)]="customer.phone"
                  #phoneNumber="ngModel" [ngClass]="{ 'is-invalid': f.submitted && phoneNumber.invalid }" required [maxlength]="maxLengthPhone"
                  [pattern]="phonePattern2" />
                <button mat-button *ngIf="customer.phone" type="button" matSuffix mat-icon-button aria-label="Clear"
                  (click)="customer.phone=''">
                  <mat-icon>close</mat-icon>
                </button>
                <mat-error *ngIf="(f.submitted || phoneNumber.invalid) && phoneNumber?.errors?.required">
                  {{'validation.phone' | translate}}
                </mat-error>
                <mat-error *ngIf="(f.submitted || phoneNumber.invalid) && phoneNumber?.errors?.pattern">
                  {{'validation.phone_format_upgrade' | translate}}
                </mat-error>
              </mat-form-field>
            </div>

            <!-- checkbox -->
            <div *ngIf="entType==1" class="col-md-4 align-items-center d-flex" style="height: 83.5px;">
              <mat-checkbox [(ngModel)]="customer.isSmsSend" name="isSmsSend">
                <span style="font-size:14px;">{{'search_form.send_info_sms' |translate}}</span>
              </mat-checkbox>
            </div>
          </div>
        </mat-expansion-panel>

        <!-- Thông tin thanh toán -->
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title class="mat-panel-title">
              {{'title.pay_info' | translate}}
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="row">
            <!-- số tài khoản -->
            <div class="col-md-6">
              <mat-form-field class="w-100">
                <input (focusout)="customer.accountNumber=customer.accountNumber.trim()" matInput autocomplete="off"
                  [placeholder]="'form.accnumber' | translate" type="text" name="accountNumber"
                  [(ngModel)]="customer.accountNumber" #accountNumber="ngModel" [maxlength]="accountNumberMaxlength" />
                <button mat-button *ngIf="customer.accountNumber" type="button" matSuffix mat-icon-button
                  aria-label="Clear" (click)="customer.accountNumber=''">
                  <mat-icon>close</mat-icon>
                </button>
                <mat-error *ngIf="f.submitted || accountNumber?.invalid || accountNumber?.errors?.validIp">
                  {{'validation.account_number' | translate}}
                </mat-error>
              </mat-form-field>
            </div>

            <!-- Chủ tài khoản -->
            <div class="col-md-6">
              <mat-form-field class="w-100">
                <input (focusout)="customer.accountName=customer.accountName.trim()" matInput autocomplete="off"
                  [placeholder]="'form.accountName' | translate" type="text" name="accountName" [(ngModel)]="customer.accountName" />
                <button mat-button *ngIf="customer.accountName" type="button" matSuffix mat-icon-button aria-label="Clear"
                  (click)="customer.accountName=''">
                  <mat-icon>close</mat-icon>
                </button>
              </mat-form-field>
            </div>
          </div>
          <div class="row">
            <!-- ngân hàng -->
            <div class="col-md-6">
              <!-- <mat-form-field class="w-100">
                <input (focusout)="customer.bankName=customer.bankName.trim()" matInput autocomplete="off"
                  [placeholder]="'form.bank' | translate" type="text" name="bankName" [(ngModel)]="customer.bankName"
                  maxlength="200" />
                <button mat-button *ngIf="customer.bankName" type="button" matSuffix mat-icon-button aria-label="Clear"
                  (click)="customer.bankName=''">
                  <mat-icon>close</mat-icon>
                </button>
              </mat-form-field> -->

              <mat-form-field class="w-100">
                <mat-select #bankSelect (focusout)="(checkFocus = true)"
                  (focus)="commonService.openComboBox(checkFocus, bankSelect)" id="bankSelect" name="bankName"
                  (selectionChange)="checkFocus = false;"
                  [(ngModel)]="customer.bankName"
                  [placeholder]="'form.bank' | translate"
                >
                  <mat-option>
                    <ngx-mat-select-search [noEntriesFoundLabel]="'autocomplete.suggestion' | translate"
                      [placeholderLabel]="'search_form.search' | translate" [formControl]="bankFilterCtrl">
                    </ngx-mat-select-search>
                  </mat-option>
                  <mat-option [value]="null" mat-selected>{{'form.select_address' | translate}}</mat-option>
                  <mat-option *ngFor="let bankName of filteredBankName | async" [value]="bankName.key"
                    (click)="this.commonService.closeDropdownList(this.bankSelect)"
                    title="{{bankName.value}}">
                    {{bankName.value}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <!-- chi nhánh -->
            <div class="col-md-6">
              <mat-form-field class="w-100">
                <input (focusout)="customer.bankBranch=customer.bankBranch.trim()" matInput autocomplete="off"
                  type="text" [placeholder]="'search_form.branch' | translate" name="bankBranch"
                  [(ngModel)]="customer.bankBranch" maxlength="100" />
                <button mat-button *ngIf="customer.bankBranch" type="button" matSuffix mat-icon-button
                  aria-label="Clear" (click)="customer.bankBranch=''">
                  <mat-icon>close</mat-icon>
                </button>
              </mat-form-field>
            </div>
          </div>
        </mat-expansion-panel>

        <!-- Tệp đính kèm -->
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title class="mat-panel-title">
              {{'title.attach' | translate}}
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="pb-3">
            <app-upload-multi-file (hasChange)="onAttachmentChange($event)" [isCustomer]="true"></app-upload-multi-file>
            <mat-hint class="hint-text">
              {{'hint.attach_accept_pdf_image' | translate}}<br>
              {{'hint.attach_accept_pdf_image_sub' | translate}}
            </mat-hint>
          </div>
        </mat-expansion-panel>

        <!-- Hồ sơ khách hàng -->
        <mat-expansion-panel expanded="true">
          <mat-expansion-panel-header>
            <mat-panel-title class="mat-panel-title">
              {{ customer.customerType == enumCustomerType.PERSONAL ? ('title.customer_information' | translate) : ('title.enterprise_information' | translate)}}
            </mat-panel-title>
          </mat-expansion-panel-header>
          <app-kyc-customer-infor [listImage]="listImage" [type]="customer.customerType == enumCustomerType.PERSONAL ? 'personal' : 'enterprise'" (imageUpload)="imageUpload($event)"></app-kyc-customer-infor>
        </mat-expansion-panel>
      </mat-accordion>
    </mat-card-content>
  </mat-dialog-content>
  <!-- Huỷ bỏ & Lưu  -->
  <mat-dialog-actions align="center" class="pt-3 pb-3">
    <button mat-stroked-button color="primary" class="mr-3" (click)="onClickBtnCancel()" type="button">
      <mat-icon>cancel</mat-icon>
      {{'button.cancel' | translate}}
    </button>
    <button mat-raised-button [disabled]="!isFormChanging" type="button"
      (click)="!f.form.valid? isInvalidForm() : 'true' && f.form.valid && onAddCustomer()" color="primary">
      <mat-icon>save</mat-icon>
      {{'button.add_customer' | translate}}
    </button>
  </mat-dialog-actions>
</form>
